import type { Mappings } from "../../policyParserTypes";
import mappingDiscord from "./mapping_discord.json";
import mappingGoogle from "./mapping_google.json";
import mappingInstagram from "./mapping_instagram.json";
import mappingLinkedin from "./mapping_linkedin.json";
import mappingNetflix from "./mapping_netflix.json";
import mappingSample from "./mapping_sample_data.json";
import mappingTiktok from "./mapping_tiktok.json";

const mappings: Record<string, Mappings[]> = {
  "discord.com": mappingDiscord.mappings,
  "google.com": mappingGoogle.mappings,
  "instagram.com": mappingInstagram.mappings,
  "linkedin.com": mappingLinkedin.mappings,
  "netflix.com": mappingNetflix.mappings,
  sample: mappingSample.mappings,
  "tiktok.com": mappingTiktok.mappings,
};

export { mappings };
